
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../utils/vendor/apiRequest";
import InputField from "../../ui/form/InputField";
import Button from "../../ui/utils/Button";
import usePost from "../../../hooks/api/usePost";
import Alert from "../../ui/utils/Alert";
import FileInputField from "../../ui/form/FileInputField";


const ProductEdit = ({ data, closeModal, callback }) => {
  const [preview, setPreview] = useState(null);

  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.editProductImage);


  const formik = useFormik({
    initialValues: {
      description: data?.description,
      image: "",
      removeBg: false,

    },
    validationSchema: Yup.object({
      description: Yup.string().required("Description is required"),
      image: Yup.mixed().test(
        "fileType",
        "Invalid file type",
        (value) =>
          !value ||
          ["image/jpeg", "image/png", "image/webp"].includes(value.type)
      ),
     
    }),
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("description", values.description);
      formData.append("image", values.image);
     const response = await post({ data: { formData, id: data?._id } });
      if (response?.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });

  return (
   <div>
            <h2 className="p-4 text-lg font-semibold">Update Product</h2>
            <div className="border-b" />
            <form onSubmit={formik.handleSubmit} className="text-sm">
                {error && <Alert message={error} type="error" />}
                <div className="grid grid-cols-1 gap-2 px-3">
                    <InputField
                        name="description"
                        label="Description"
                        placeholder="Enter description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        serverError={serverErrors?.description}
                        error={formik.touched.description && formik.errors.description}
                    />

                <div className="col-span-full">
                    <FileInputField
                        error={formik.touched.image && formik.errors.image}
                        id="image"
                        label="Image"
                        accept="image/*"
                        onChange={(e) => {
                            const file = e.currentTarget.files?.[0] || "";
                            formik.setFieldValue("image", file);
                            setPreview(file ? URL.createObjectURL(file) : "");
                        }}
                    />
                    {preview && (
                        <img
                            src={preview}
                            alt="Preview"
                            className="object-contain w-20 h-20 mt-2 border rounded"
                        />
                    )}
                </div>
                </div>


                <div className="border-b" />
                <div className="flex justify-end gap-2 p-4">
                    <Button variant="secondary" onClick={closeModal}>
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="primary"
                        loadingText="Updating..."
                        isLoading={loading}
                    >
                        Update
                    </Button>
                </div>
            </form>
        </div>
  );
};

export default ProductEdit;


